import { useMemo } from 'react';
import managed from '../get/managed';

/**
 * @param {Object} snapshot
 * @param {Object} relations
 * @param {String} personId
 * @returns {Object}
 */
export default function useManagedEntities(snapshot, relations, personId) {
  return useMemo(() => {
    return managed(snapshot, relations, personId);
  }, [snapshot?.__hash, personId]);
}
